import React, { Component } from 'react';
import "./SeparatorItem.scss";

export default class SeparatorItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {cols=14} = this.props;

    return (
      <tr className="separator-row">
        {
          [...Array(cols)].map((item, index) => <td key={index}/>)
        }
      </tr>
    )
  }
}
